export default __webpack_public_path__ + "static/media/ptpt.45532a02.jpg";